import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const WifiIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "WifiGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.7198 19.4403C13.5013 19.4403 14.1349 18.8068 14.1349 18.0253C14.1349 17.2438 13.5013 16.6103 12.7198 16.6103C11.9383 16.6103 11.3048 17.2438 11.3048 18.0253C11.3048 18.8068 11.9383 19.4403 12.7198 19.4403Z"
        fill="#696969"
      />
      <path
        d="M8.72452 15.6177C8.62247 15.6177 8.51944 15.5864 8.43057 15.522C8.20743 15.3589 8.15811 15.0464 8.32119 14.8228C9.34267 13.4214 10.9872 12.5845 12.7196 12.5845C14.3974 12.5845 15.956 13.3413 16.996 14.6616C17.1669 14.8784 17.1298 15.1929 16.913 15.3638C16.6962 15.5357 16.3827 15.4976 16.2108 15.2808C15.3612 14.2026 14.0888 13.5845 12.7196 13.5845C11.3056 13.5845 9.96328 14.2681 9.12881 15.4126C9.03115 15.5464 8.87882 15.6177 8.72452 15.6177Z"
        fill="#696969"
      />
      <path
        d="M6.05167 12.7476C5.93546 12.7476 5.81876 12.7075 5.72403 12.6255C5.51553 12.4448 5.49307 12.1284 5.67374 11.9204C7.44718 9.87549 10.015 8.70264 12.7196 8.70264C15.3886 8.70264 17.934 9.84912 19.703 11.8481C19.8861 12.0542 19.8666 12.3706 19.6601 12.5532C19.4535 12.7378 19.1381 12.7183 18.954 12.5103C17.3749 10.7261 15.1025 9.70264 12.7196 9.70264C10.3056 9.70264 8.01261 10.7495 6.4296 12.5747C6.33048 12.689 6.19132 12.7476 6.05167 12.7476Z"
        fill="#696969"
      />
      <path
        d="M3.21964 9.70166C3.09757 9.70166 2.9755 9.65771 2.87931 9.56787C2.67716 9.38037 2.66544 9.06396 2.85343 8.86182C5.39298 6.12744 8.98917 4.56006 12.7196 4.56006C16.4491 4.56006 20.0453 6.12744 22.5858 8.85986C22.7738 9.06201 22.7621 9.37841 22.56 9.56689C22.3583 9.75537 22.0424 9.74267 21.8534 9.5415C19.5014 7.01123 16.1723 5.56005 12.7196 5.56005C9.26603 5.56005 5.93693 7.01122 3.58585 9.5415C3.48722 9.64795 3.35343 9.70166 3.21964 9.70166Z"
        fill="#696969"
      />
    </svg>
  );
};

export default WifiIcon;
